/* eslint-disable react/react-in-jsx-scope */
import {useState} from 'react';
import {Link} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import {FcNext, FcPrevious} from 'react-icons/fc';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../index.css';

export default function Pagination({
  postsPerPage,
  totalPosts,
  paginate,
  currentPage
}) {
  const totalPages = Math.ceil(totalPosts / postsPerPage);

  const pageNumber = [];
  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i += 1) {
    pageNumber.push(i);
  }
  const getCurrentPage = (page) => Number(page);
  const currentPageNumber = getCurrentPage(currentPage);
  // const totalPages = pageNumber.length;
  const next = () => {
    if (currentPageNumber === totalPages) {
      paginate(currentPageNumber);
    } else {
      paginate(currentPageNumber + 1);
    }
  };

  const prev = () => {
    if (currentPageNumber === 1) {
      paginate(currentPageNumber);
    } else {
      paginate(currentPageNumber - 1);
    }
  };

  return (
    <div className="Pagination">
      <Button
        variant="light"
        className="pagebtn"
        onClick={prev}
        disabled={currentPageNumber === 1}
      >
        <FcPrevious />
      </Button>{' '}
      {pageNumber.map((number) => {
        if (number < currentPageNumber + 6 && number > currentPageNumber - 6) {
          return (
            <li key={number}>
              <Link
                to=""
                onClick={() => paginate(number)}
                className={number === currentPageNumber ? 'active' : ''}
              >
                {number}
              </Link>
            </li>
          );
        }
        return null;
      })}
      <Button
        variant="light"
        className="pagebtn"
        onClick={next}
        disabled={currentPageNumber >= totalPages}
      >
        <FcNext />
      </Button>{' '}
    </div>
  );
}
